import React, { useState, useEffect, useContext } from 'react';
import { useRefinementList } from 'react-instantsearch-hooks-web';
import { SORT_TYPES, sortFilter } from '../../constants/search';
import appContext from '../../Context/appContext';
import { GANJAGODDESS } from '../../constants/website';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedPriceSort } from '../../redux/slices/searchSlice';

const isGG = process.env.NEXT_PUBLIC_APP === GANJAGODDESS;

export default function ListFilterItem({ filter, setListLoading }) {

  const { filterType, title, type, attribute } = filter;

  // const {
  //   // state: {
  //   //   search: { selectedPriceSort }
  //   // },
  //   dispatch
  // } = useContext(appContext);
  const selectedPriceSort = useSelector(state => state.search.selectedPriceSort)
  const dispatchRedux = useDispatch()


  const { items, refine, searchForItems } = useRefinementList({
    attribute,
    limit: 30,
    showMoreLimit: 30,
    // sortBy: ['count:desc', 'name:asc']
  });
  const [searchQuery, setSearchQuery] = useState('');

  const handleChange = e => {
    setSearchQuery(e.target.value);
    searchForItems(e.target.value);
  };

  const onSortChange = event => {
    setListLoading(true);
    const { value } = event.target;
    // dispatch({ type: 'setSelectedPriceSort', payload: value });

    dispatchRedux(setSelectedPriceSort(value))

    window.scrollTo(0, 0);
    setTimeout(() => setListLoading(false), 500);
  };


  useEffect(() => {
    setSearchQuery("");
  }, [])

  if (items) {
    return (
      <div className="filter-dropdown" id='filter-list-item'>
        <div className="f-search-parent">
          {filterType === 'search' && (attribute === 'full_shop_categories' || attribute === 'brands') && (
            <div className="mt-1 search-input">
              <i className="icon-search" />
              <input id='options-input' value={searchQuery} className="form-control mb-2 mt-1" placeholder={`Search ${title}`} onChange={handleChange} />
            </div>
          )}
        </div>
        <div className={`filters-dropdown-list ${filterType}`}>
          {
            attribute == 'sort' ?
              sortFilter.map(item => (
                <div key={`${item.label}`} className={`custom-${type} mt-2 d-block`}>
                  <input
                    id={`${item.label}`}
                    type="radio"
                    value={item.id}
                    checked={selectedPriceSort ? selectedPriceSort === item.id : isGG ? item.id == SORT_TYPES.recommeded
                      : item.id == SORT_TYPES.deals}
                    onChange={onSortChange}
                  />
                  <label htmlFor={`${item.label}`}>{item.label}</label>
                </div>
              )) :
              items.map((item) => {
                return (
                  <div key={`${item.label}-${item.isRefined}`} className={`custom-${type} mt-2 d-block`}>
                    <input checked={item.isRefined} type={type} id={`${item.label}-${item.count}-${attribute}`}
                      name={attribute}
                      value={item.value}
                      onChange={event => {
                        setListLoading(true);
                        event.preventDefault();
                        refine(item.value);
                        window.scrollTo(0, 0);
                        setTimeout(() => setListLoading(false), 500);
                      }} />
                    <label htmlFor={`${item.label}-${item.count}-${attribute}`} className="">
                      {`${item.label} (${item.count})`}
                    </label>
                  </div>
                );
              })
          }

        </div>
      </div>
    );
  }

  return null;

}
